"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapLink = exports.upsertLinkAtSelection = exports.unwrapLink = exports.setLink = void 0;
var _slate = require("slate");
var _slatePlugins = require("@udecode/slate-plugins");
var _element = _interopRequireDefault(require("./element"));
var setLink = exports.setLink = function setLink(_ref) {
  var editor = _ref.editor,
    url = _ref.url,
    options = _ref.options;
  var _setDefaults = (0, _slatePlugins.setDefaults)(options, _element["default"]),
    at = _setDefaults.at,
    link = _setDefaults.link;
  var wrappedElement = {
    type: link.type,
    url: url
  };
  _slate.Transforms.setNodes(editor, wrappedElement, {
    at: at,
    split: true
  });
};
var wrapLink = exports.wrapLink = function wrapLink(_ref2) {
  var editor = _ref2.editor,
    url = _ref2.url,
    options = _ref2.options;
  var _setDefaults2 = (0, _slatePlugins.setDefaults)(options, _element["default"]),
    at = _setDefaults2.at,
    link = _setDefaults2.link;
  _slate.Transforms.wrapNodes(editor, {
    type: link.type,
    url: url,
    children: []
  }, {
    at: at,
    split: true
  });
};
var unwrapLink = exports.unwrapLink = function unwrapLink(_ref3) {
  var editor = _ref3.editor,
    options = _ref3.options;
  var _setDefaults3 = (0, _slatePlugins.setDefaults)(options, _element["default"]),
    at = _setDefaults3.at,
    link = _setDefaults3.link;
  (0, _slatePlugins.unwrapNodesByType)(editor, link.type, {
    at: at
  });
};
var upsertLinkAtSelection = exports.upsertLinkAtSelection = function upsertLinkAtSelection(editor, url, options) {
  if (!editor) return null;
  var _setDefaults4 = (0, _slatePlugins.setDefaults)(options, _element["default"]),
    link = _setDefaults4.link,
    wrap = _setDefaults4.wrap;
  if (!wrap && (0, _slatePlugins.isCollapsed)(editor.selection)) {
    return _slate.Transforms.insertNodes(editor, {
      type: link.type,
      url: url,
      children: [{
        text: url
      }]
    });
  }
  (0, _slatePlugins.unwrapNodesByType)(editor, link.type, {
    at: editor.selection
  });
  wrapLink({
    editor: editor,
    url: url,
    options: {
      link: link,
      at: editor.selection
    }
  });
  _slate.Transforms.collapse(editor, {
    edge: 'end'
  });
  return null;
};